<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4462_1590)">
      <path
        d="M17 6.8826L17 5.29436L7.54546 5.29436L5.64516 3.00024L1 3.00024L1 6.00024L1 16.0002L9 16.0002L12.5 16.0002L17 16.0002L17 12.0002"
        stroke="#1D1E20"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4462_1590">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
